import { AuthService } from '@account/services/auth.service';
import { Component, OnInit, Input, ViewEncapsulation, inject } from '@angular/core';
import { EXTRANETJS_URLS, BavelMenu, BAVEL_APP_MENUS } from '@config/app-menu';
import { IBavelPageHeader } from '@tool/interfaces/bavel-page-header.interface';
import { IUserProfileInfo } from '@shared/interfaces/user-profile-info.interface';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { IUsersService } from '@shared/interfaces/users-service.interface';

@Component({
    selector: 'bv-tool-topbar',
    templateUrl: './tool-topbar.component.html',
    styleUrls: ['./tool-topbar.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class ToolTopbarComponent implements OnInit {
  @Input() public userProfile: IUserProfileInfo | undefined;
  public userId: string | undefined;
  public userName: string = '';
  public loginName: string | undefined;
  public pageHeader: IBavelPageHeader = {};
  public preferencesUrl: string = EXTRANETJS_URLS.paths.PREFERENCES;

  private authService: AuthService = inject(AuthService);
  private router: Router = inject(Router);
  private translateService: TranslateService = inject(TranslateService);
  private usersService: IUsersService = inject(IUsersService);

  /* eslint-disable @typescript-eslint/no-non-null-assertion */
  public ngOnInit(): void {
    this.userId = `#${this.usersService.currentUser.id}`;
    this.userName = this.userProfile?.contactName ?
      `${this.userProfile?.contactName} ${this.userProfile?.contactSurname1}` : '';
    this.loginName = this.userProfile?.loginName ?? '';

    // Title and icon
    const menuItem = BAVEL_APP_MENUS.find((item: BavelMenu) => this.router.url.includes(item.url!));
    if (menuItem) {
      this.pageHeader = {
        pageTitle: menuItem.pageTitle,
        iconTitleSrc: menuItem.iconTitleSrc,
        faIcon: menuItem.faIcon
      };
    }
  }

  public logout(): void {
    this.authService.logout();
  }

  public goToPreferences(): void {
    // Necessary to get new language specified in blackbirdjs
    let url = window.location.href;
    if (window.location.href.includes('lang')) url = window.location.href.substring(0, window.location.href.lastIndexOf('?lang'));
    window.location.href = EXTRANETJS_URLS.paths.PREFERENCES + '?callFrom=' + url;
  }

  public get profileImgSrc(): string {
    return this.userProfile?.isEstab ?
      'assets/images/icons/profiles/icon-company-navbar-top.png' :
      'assets/images/icons/profiles/building-bluelight-line.png';
  }
  public get userKindDisplay(): string {
    const TOKEN = this.userProfile?.isEstab ?
      'Web_Osprey_Matching_Table_Estab_Header' :
      'Web_Extranet_Tpn_WorkView_Enterprise_Name_Label';
    return this.translateService.instant(TOKEN);
  }
}
